import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useLocation } from 'react-router-dom';
import BB from '../images/BB.png';
import Tile from '../images/Tile.png';
import {  faBookOpen, faClose, faCog, faCube, faPhone, faRuler, faShield, faStar, faStarHalfStroke, faSwatchbook
   ,faTimesCircle} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import TilesIcon from '../images/tilesicon.jpg';
import Bath from '../images/roomicons/bath.png';
import Bedroom from '../images/roomicons/bed.png';
import Dining from '../images/roomicons/dine.png';
import Kitchen from '../images/roomicons/kitchen.png';
import Living from '../images/roomicons/living.png';
import Pooja from '../images/roomicons/pooja.png';
import Balcony from '../images/roomicons/balcony.png';
import Wash from '../images/roomicons/wash.png';
import Header from '../Component/Header';
import ProjectHeader from '../Component/ProjectHeader';

function TilesStandardQuoteDetails() {
  const navigate = useNavigate();
     const location = useLocation();
     const quotationId = location?.state?.quotationId
     const type = location?.state?.type
     console.log(type)
     const [data , setData] = useState({});
console.log(data);
     const [designs , setDesigns] = useState([]);
     const [showDesignsPopup, setShowDesignsPopup] = useState(false);
     const [selectedItem, setSelectedItem] = useState(null);
     //console.log(selectedItem);
// Add this state at the top of your component
     const [selectedAreas, setSelectedAreas] = useState([]);
//console.log(selectedAreas);
const [selectedDesign, setSelectedDesign] = useState(null);
const [selectedDesignForPopup, setSelectedDesignForPopup] = useState(null);
const [isApplyingDesign, setIsApplyingDesign] = useState(false);
const [showToast, setShowToast] = useState(false);
const [toastMessage, setToastMessage] = useState('');
const [minimumLoadTimePassed, setMinimumLoadTimePassed] = useState(false);
const [showAllAreas, setShowAllAreas] = useState({});
const [showVendorDetailsPopup, setShowVendorDetailsPopup] = useState(false);
const [selectedVendorDetails, setSelectedVendorDetails] = useState(null);

// Function to toggle showing all areas for a specific item
const toggleShowAllAreas = (itemId) => {
  setShowAllAreas(prev => ({
    ...prev,
    [itemId]: !prev[itemId]
  }));
};


  useEffect(() => {
      fetchQuotationDetails();
  }, [quotationId]);

    const fetchQuotationDetails = async () => {
      const token = sessionStorage.getItem('token');
      try {
        const response = await fetch(`${process.env.REACT_APP_FORE_BRICKBUCKET}customer/quotations/get-quote?quotation_id=${quotationId}`, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'x-token': token
          }
        });
               
        const data = await response.json();
        console.log(data)
        console.log(data.data.quotation);
        setData(data.data.quotation);
        return data.data.quotation;
        //console.log(sampleData)
      } catch (err) {
        console.error('Error fetching quotation details:', err);
      }
    };
    
    const handleSelectTileDesignClick = async (item) => {
      setSelectedItem(item); // Store the selected item
      
      try {
        const token = sessionStorage.getItem('token');
        
        // Make the API call
        const response = await fetch(`${process.env.REACT_APP_FORE_BRICKBUCKET}product/get-products-by-product-group?product_group_id=${item.item_id}`, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'x-token': token
          }
        });
        
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        
        const responseData = await response.json();
        
        if (responseData.success) {
          setDesigns(responseData.data); // Set the fetched data in the state
          setShowDesignsPopup(true); // Show the popup after data is loaded
          console.log(responseData);
        } else {
          console.error('Error fetching tile designs:', responseData.message);
          // Optionally show an error message to the user
        }
      } catch (error) {
        console.error('Failed to fetch tile designs:', error);
        // Handle error appropriately
      }
    };
    
    // Add a function to handle design selection
    const handleDesignSelect = async (design) => {
      if (selectedAreas.length === 0) {
        alert("Please select at least one area to apply the design.");
        return;
      }
    
      // Start timer and loading state
      const startTime = Date.now();
      setIsApplyingDesign(true);
      setMinimumLoadTimePassed(false);
      
      // Set minimum display time
      setTimeout(() => {
        setMinimumLoadTimePassed(true);
      }, 2000);
    
      try {
        const token = sessionStorage.getItem('token');
        const payload = {
          quotationId: quotationId,
          item_id: selectedItem.item_id || selectedItem._id,
          design_id: design.item_id || design._id,
          applied_areas: selectedAreas.map(area => area.area_name)
        };
        
        const response = await fetch(`${process.env.REACT_APP_FORE_BRICKBUCKET}customer/quotations/update-selected-designs`, {
          method: 'PUT',
          headers: {
            'Content-Type': 'application/json',
            'x-token': token
          },
          body: JSON.stringify(payload)
        });
        
        // Ensure minimum load time has passed
        const elapsed = Date.now() - startTime;
        if (elapsed < 2000) {
          await new Promise(resolve => setTimeout(resolve, 2000 - elapsed));
        }
        
        if (!response.ok) throw new Error(`HTTP error! Status: ${response.status}`);
        
        const responseData = await response.json();
        
        if (responseData.success) {
          const updatedQuotation = await fetchQuotationDetails();
          
          if (updatedQuotation) {
            const updatedItem = updatedQuotation.items.find(
              item => item.item_id === selectedItem.item_id || item._id === selectedItem._id
            );
            if (updatedItem) setSelectedItem(updatedItem);
          }
          
          setToastMessage("Design applied successfully!");
          setShowToast(true);
          setTimeout(() => setShowToast(false), 3000); // Auto-dismiss after 3 seconds
          setSelectedAreas([]);
          setSelectedDesign(null);
        } else {
          throw new Error(responseData.message || "Failed to apply design");
        }
      } catch (error) {
        setToastMessage(`Error: ${error.message}`);
        setShowToast(true);
        console.error("Error in handleDesignSelect:", error);
      } finally {
        setIsApplyingDesign(false);
      }
    };
    
    
    
    
// Add this function to handle area selection
const handleAreaSelection = (area) => {
  //console.log("Selected area:", area);
  
  setSelectedAreas(prev => {
    // Check if this area is already in the array by comparing area_name
    const isAlreadySelected = prev.some(selectedArea => selectedArea.area_name === area.area_name);
    
    if (isAlreadySelected) {
      // If already selected, remove it
      return prev.filter(selectedArea => selectedArea.area_name !== area.area_name);
    } else {
      // If not selected, add the entire area object
      return [...prev, area];
    }
  });
};


const handleCustomizeClick = () => {
  console.log("Navigating to customize with type:", type); // Log before navigation
  navigate('/consumer/app/tilescustomize', { 
    state: { 
      data, 
      type: type
    } 
  });
};

      const handleProceedClick = () => {
        navigate('/consumer/app/proceed', { state: { quotationId } }); // Navigate with state
      };

      // Helper function to get the appropriate icon based on area name
const getRoomIcon = (areaName) => {
  const lowerCaseName = areaName.toLowerCase();
  
  if (lowerCaseName.includes('bath')) return Bath;
  if (lowerCaseName.includes('bed') || lowerCaseName.includes('master')) return Bedroom;
  if (lowerCaseName.includes('dining') || lowerCaseName.includes('dine')) return Dining;
  if (lowerCaseName.includes('kitchen')) return Kitchen;
  if (lowerCaseName.includes('living') || lowerCaseName.includes('hall')) return Living;
  if (lowerCaseName.includes('pooja') || lowerCaseName.includes('prayer')) return Pooja;
  if (lowerCaseName.includes('balcony') || lowerCaseName.includes('terrace')) return Balcony;
  if (lowerCaseName.includes('wash') || lowerCaseName.includes('utility')) return Wash;
  
  // Default to Living room icon if no match is found
  return Living;
};


const handleVendorImageClick = (vendor) => {
  setSelectedVendorDetails(vendor);
  setShowVendorDetailsPopup(true);
};
console.log("data:---",data)
return(
<div className="bg-gray-100">
<Header />
{console.log(data.buildcoins)}

  {/* Project Info Header - Made sticky */}
  <ProjectHeader 
  projectName={data?.project_id?.projectName}
  type={'Quote Summary'}
  categoryName={data?.product_category_id?.product_category_name}
  Name={data?.customized_by ? data.quotation_number : (data?.package_name || data?.quotation_number)}
  Title={data?.customized_by ? 'My Saved Quote' : 'Quote by Brickbucket'}
buildcoins={
    data?.buildcoins && Array.isArray(data.buildcoins)
      ? data.buildcoins.reduce((sum, item) => sum + (item?.reserved_coins ?? 0), 0)
      : 0
  } 
  />

  {/* Scrollable Content Area */}
  <div className='p-4 pt-2 mb-28'>
    {data?.items?.map((item) => (
      <div key={item.vendor.id + item.item_name} className="border bg-white shadow-md rounded-lg overflow-hidden mb-4"> 
        <div className="px-4 py-2">
          <div className="flex flex-row items-center mb-1"> {/* Flexbox for image and title */}
            <img onClick={() => handleVendorImageClick(item.vendor)}
            src={process.env.REACT_APP_FORE_BRICKBUCKET_IMAGES + item.vendor.image} alt={item.vendor.name} className="border border-2 w-10 h-10 rounded-md mr-2" />
            <div className='flex justify-between w-full'>
              <div className="flex flex-col">
                <h5 className=" text-gray-700 text-md font-semibold line-clamp-2">
                  {item.vendor.name}
                </h5> 
                {/* Attribute badges */}
                <div className="flex flex-wrap gap-1 mb-2">
                  {/* Finish attribute badge with color coding */}
                  {item.attributes?.find(attr => attr.attribute_name === "finish") && (() => {
                    const finishValue = item.attributes.find(attr => attr.attribute_name === "finish").attribute_value;
                    const finishValueLower = finishValue.toLowerCase();
                    
                    // Determine color based on finish type
                    let bgColor, textColor;
                    if (finishValueLower.includes('glossy')) {
                      bgColor = 'bg-gray-200';
                      textColor = 'text-gray-800';
                    } else if (finishValueLower.includes('matt') || finishValueLower.includes('matte')) {
                      bgColor = 'bg-gray-200';
                      textColor = 'text-gray-800';
                    } else if (finishValueLower.includes('rustic') || finishValueLower.includes('textured')) {
                      bgColor = 'bg-red-100';
                      textColor = 'text-red-800';
                    } else {
                      bgColor = 'bg-gray-100';
                      textColor = 'text-gray-800';
                    }
                    
                    return (
                      <span className={`inline-flex items-center px-2 py-0.5 rounded-full text-sm font-medium ${bgColor} ${textColor}`}>
                        {finishValue}
                      </span>
                    );
                  })()}
                  
                  {/* Size attribute badge with color coding */}
                  {item.attributes?.find(attr => attr.attribute_name === "size") && (() => {
                    const sizeValue = item.attributes.find(attr => attr.attribute_name === "size").attribute_value;
                    const sizeValueNormalized = sizeValue.toLowerCase().replace(/\s+/g, '');
                    
                    // Helper function to check size regardless of "mm" format
                    const checkSize = (size) => {
                      const pattern = size.replace(/x/g, '\\s*[xX]\\s*').replace(/mm/g, '\\s*(?:mm|MM|Mm|mM)?');
                      return new RegExp(pattern, 'i').test(sizeValueNormalized);
                    };
                    
                    // Determine color based on size - avoiding yellow
                    let bgColor, textColor;
                    if (checkSize('600x1200mm') || checkSize('1200x600mm')) {
                      bgColor = 'bg-gray-100';
                      textColor = 'text-gray-800';
                    } else if (checkSize('600x600mm')) {
                      bgColor = 'bg-gray-200';
                      textColor = 'text-gray-800';
                    } else if (checkSize('1200x1800mm') || checkSize('1800x1200mm')) {
                      bgColor = 'bg-gray-100';
                      textColor = 'text-gray-800';
                    } else if (checkSize('800x1600mm') || checkSize('1600x800mm')) {
                      bgColor = 'bg-gray-200';
                      textColor = 'text-gray-800';
                    } else if (checkSize('600x300mm') || checkSize('300x600mm')) {
                      bgColor = 'bg-gray-200';
                      textColor = 'text-gray-800';
                    } else {
                      bgColor = 'bg-gray-100';
                      textColor = 'text-gray-700';
                    }
                    
                    return (
                      <span className={`inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium ${bgColor} ${textColor}`}>
                        {sizeValue}
                      </span>
                    );
                  })()}
                </div>
              </div>
            </div>
          </div>
          
          <div className="pt-4 border-t border-gray-200 mb-3">
            <div className="mb-2">
              <h4 className="text-sm font-bold text-gray-700 flex items-center">
                Applied Areas
              </h4>
            </div>

            <div className="flex flex-col bg-gray-50 rounded-lg overflow-hidden border border-gray-200 shadow-sm">
              {/* Areas Container */}
              <div className="flex flex-row">
                {/* Left Column */}
                <div className="flex-1 p-2">
                  {(showAllAreas[item.item_id] 
                    ? item.applied_areas.slice(0, Math.ceil(item.applied_areas.length / 2)) 
                    : item.applied_areas.slice(0, 2)
                  ).map((area) => (
                    <div
                      className='flex flex-row items-center gap-2 py-1.5 px-2 mb-1.5 bg-white rounded-md border-l-3 border-[#D64541] shadow-sm hover:shadow transition-all'
                      key={area._id || area.id}
                    >
                      {/* Updated: Larger container + image size */}
                      <div className=" rounded-full flex items-center justify-center">
                        <img
                          src={getRoomIcon(area.area_name)}
                          alt={area.area_name}
                          className="h-12 w-14 object-contain"
                        />
                      </div>
                      <p className="text-xs font-bold text-gray-700">{area.area_name}</p>
                    </div>
                  ))}
                </div>

                {/* Right Column */}
                <div className="flex-1 p-2">
                  {(showAllAreas[item.item_id]
                    ? item.applied_areas.slice(Math.ceil(item.applied_areas.length / 2))
                    : item.applied_areas.slice(2, 4)
                  ).map((area) => (
                    <div
                      className='flex flex-row items-center gap-2 py-1.5 px-2 mb-1.5 bg-white rounded-md border-l-3 border-[#D64541] shadow-sm hover:shadow transition-all'
                      key={area._id || area.id}
                    >
                      {/* Updated: Larger container + image size */}
                      <div className="rounded-full flex items-center justify-center">
                        <img
                          src={getRoomIcon(area.area_name)}
                          alt={area.area_name}
                          className="h-12 w-14 object-contain"
                        />
                      </div>
                      <p className="text-xs font-bold text-gray-700">{area.area_name}</p>
                    </div>
                  ))}
                </div>
              </div>
              
              {/* View All Button - Only show if there are more than 4 areas */}
              {item.applied_areas.length > 4 && (
                <div className="px-3 pb-3 flex justify-between">
                  <p className='text-xs'>Total: {item.applied_areas.length} Areas</p>
                  <button
                    onClick={() => toggleShowAllAreas(item.item_id)}
                    className="text-xs font-medium text-[#e8001c] hover:text-[#e8001c] flex items-center group"
                  >
                    {showAllAreas[item.item_id] ? (
                      <>
                        <span>View Less</span>
                        <svg className="w-4 h-4 ml-1 text-[#e8001c] group-hover:text-[#e8001c]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 15l7-7 7 7" />
                        </svg>
                      </>
                    ) : (
                      <>
                        <span>View All </span>
                        <svg className="w-4 h-4 ml-1 text-[#e8001c] group-hover:text-[#e8001c]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7" />
                        </svg>
                      </>
                    )}
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>
        
        {/* Tile Design Selection/Display Section */}
        <div className="mx-4 mb-2 rounded-md border border-gray-300 overflow-hidden">
      {item.applied_areas.some(area => area.selected_design && area.selected_design.design_id) ? (
  // When designs are selected, show carousel and change button
  <div className="flex flex-col w-full">
  {/* Fixed header section */}
  <div className="flex flex-row justify-between items-center py-1 px-2 border-b border-gray-300">
    <div className='flex flex-row items-center'>
      <img src={TilesIcon} alt="Box" className="h-8 w-10" />
      <h4 className="font-bold text-sm text-gray-600 text-left">
        Tile Designs
      </h4>
    </div>
    <button
  onClick={() => handleSelectTileDesignClick(item)}
  className="rounded-md border-b border-dotted border-[#e8001c] px-2  flex flex-row items-center text-sm text-[#e8001c] font-medium hover:text-[#e8001c] "
>
 {/*  <svg xmlns="http://www.w3.org/2000/svg" className="h-3.5 w-3.5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.572L16.732 3.732z" />
  </svg> */}
  <p >Change</p>
</button>


  </div>
  
  {/* Scrollable design preview section */}
  <div className="p-2">
  <div 
  className="design-carousel overflow-x-auto mx-auto"
  style={{ 
    width: '100%', 
    maxWidth: '300px',
    msOverflowStyle: 'none',  /* IE and Edge */
    scrollbarWidth: 'none',   /* Firefox */
    WebkitOverflowScrolling: 'touch',
    overflowY: 'auto'
  }}
>
  {/* Add this style tag inside the component or in a separate CSS file */}
  <style jsx>{`
    .design-carousel::-webkit-scrollbar {
      display: none;  /* Chrome, Safari and Opera */
    }
  `}</style>
      <div className="flex">
        {/* Map through unique designs (to avoid duplicates) */}
        {Array.from(new Set(item.applied_areas
          .filter(area => area.selected_design && area.selected_design.design_image)
          .map(area => area.selected_design.design_id)))
          .map((designId, index) => {
            // Find the first area with this design
            const areaWithDesign = item.applied_areas.find(
              area => area.selected_design && area.selected_design.design_id === designId
            );
            const design = areaWithDesign.selected_design;
            
            return (
              <button
                onClick={() => {
                  // Find all areas that use this design
                  const areasWithThisDesign = item.applied_areas.filter(
                    area => area.selected_design && area.selected_design.design_id === designId
                  );
                  
                  // Set the selected design with its areas for the popup
                  setSelectedDesignForPopup({
                    design: design,
                    areas: areasWithThisDesign
                  });
                }}
                key={designId}
                className={`flex-shrink-0 w-[130px] flex flex-col items-center mx-2 first:ml-0 hover:opacity-90 transition-opacity ${
                  index === 2 ? 'mr-[-100px]' : 'last:mr-0'
                }`}
              >
                <div className="w-[130px] h-16 overflow-hidden border border-gray-200 shadow-sm hover:shadow-md transition-shadow">
                  <img
                    src={process.env.REACT_APP_FORE_BRICKBUCKET_IMAGES + design.design_image}
                    alt={design.design_name}
                    className="w-full h-full object-cover"
                    onError={(e) => {
                      e.target.onerror = null;
                      e.target.src = "https://via.placeholder.com/100?text=No+Image";
                    }}
                  />
                </div>
                <span className="text-xs text-gray-600 mt-1.5 max-w-full px-1 truncate text-center">
                  {design.design_name}
                </span>
              </button>
            );
          })}
      </div>
    </div>
  </div>
</div>

  ) : (
    // When no designs are selected, show the original button with improved styling
    <button
      onClick={() => handleSelectTileDesignClick(item)}
      className="w-full flex flex-row items-center justify-center gap-3 py-3 px-4 hover:bg-red-50 transition-colors"
      aria-label="Select tile design"
    >
      <img
        src={Tile}
        className="w-5 h-5 object-contain"
        alt="Tile icon"
      />
      <p className='text-[#F30F0F] text-sm font-medium'>
        Select Tile Design
      </p>
    </button>
  )}
</div>
<div className='px-2 pt-0.5 pb-2'>
          <div className="rounded-md bg-gray-100 p-2 flex justify-between">
            <div>
              <p className="text-xs font-semibold text-gray-500">Quantity</p>
              <div className='mt-1 flex flex-row'>
                <p className='text-gray-700 text-sm font-semibold'>{item.areaInSft}</p>
                <p className='text-gray-500 text-xs ml-1 mt-0.5 '>Sq.Ft</p>
              </div>
            </div>
            <div>
              <p className="text-xs font-semibold text-gray-500">Unit Price</p>
              <div className='mt-1 flex flex-row'>
                <p className='text-gray-700 text-sm font-semibold'>₹{item.price_per_sqft}</p>
                <p className='text-gray-500 text-xs mt-0.5'>/Sq.Ft</p>
              </div>
            </div>
            <div>
              <p className="text-xs font-semibold text-gray-500">Price</p>
              <p className='text-md font-semibold text-[#14A311]'> ₹{Number(item.total).toLocaleString('en-IN')}</p>
            </div>
          </div>
        </div>
      </div>
    ))}
  </div>
  {/* // footer */}
 {/* Footer */}
 <div className="border-t border-gray-300 fixed bottom-0 left-0 right-0 bg-white shadow-lg p-4 flex justify-between items-center z-10">
    <div className="flex flex-col">
      <p className="text-md font-semibold">Total Price</p>
      <div className="flex flex-col items-baseline">
        <span className="text-xl font-bold text-[#14A311]">₹{Number(data.subtotal).toLocaleString('en-IN')}</span>
        <span className="text-xs text-gray-500 ml-1">(+ GST & Transport)</span>
      </div>
    </div>
    <div className="flex flex-col">
      <button onClick={handleCustomizeClick} 
        className="border border-[#e8001c] text-[#e8001c] font-bold py-1 px-4 rounded mb-1">
        Customize
      </button>
      <button onClick={handleProceedClick}
        className="flex flex-col bg-[#e8001c] text-white font-bold py-1 px-4 rounded">
        Proceed
      </button>
    </div>
  </div>
  {/* Tile Designs Popup */}
{showDesignsPopup && (
  <div className="fixed inset-0 bg-black bg-opacity-50 z-40 flex justify-center items-end">
    {/* Overlay Background */}
    <div
      className="fixed inset-0 bg-black bg-opacity-50 z-40"
      onClick={() => {
        setShowDesignsPopup(false);
        setSelectedAreas([]);
        setSelectedDesign(null);
      }}
    ></div>

    {/* Single Popup Content Container - Modified for fixed header */}
    <div className="fixed bottom-0 left-0 right-0 bg-white z-50 shadow-2xl rounded-t-2xl max-h-[85vh] flex flex-col">
      {/* Loading Overlay - Positioned correctly */}
      {isApplyingDesign && (
        <div className="absolute inset-0 bg-white bg-opacity-80 z-[60] flex items-center justify-center">
          <div className="flex flex-col items-center">
            <div className="w-12 h-12 rounded-full mb-2 flex items-center justify-center">
              <svg
                className="w-8 h-8 text-[#D64541] animate-spin"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
              >
                <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
              </svg>
            </div>
            <p className="text-gray-800 font-medium">Applying design...</p>
          </div>
        </div>
      )}

    {/* Popup - Enhanced Visual Design */}
    <div className="rounded-t-2xl px-4 pt-4 pb-3 border-b border-gray-200 flex-shrink-0 sticky top-0 bg-white z-[55]">
  <div className="flex justify-between items-start">
    <div className="flex items-start">
      <img
        src={process.env.REACT_APP_FORE_BRICKBUCKET_IMAGES + selectedItem.vendor.image}
        alt={selectedItem.vendor.name}
        className="w-12 h-12 rounded-md mr-3 border object-contain"
      />
      <div>
        <p className="font-semibold text-gray-900">{selectedItem.vendor.name}</p>
        <div className="flex flex-wrap gap-1 mt-1">
          {selectedItem.attributes?.find(attr => attr.attribute_name === "finish") && (
            <span className="inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium bg-gray-200 text-gray-800">
              {selectedItem.attributes.find(attr => attr.attribute_name === "finish").attribute_value}
            </span>
          )}
          {selectedItem.attributes?.find(attr => attr.attribute_name === "size") && (
            <span className="inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium bg-gray-100 text-gray-700">
              {selectedItem.attributes.find(attr => attr.attribute_name === "size").attribute_value}
            </span>
          )}
        </div>
      </div>
    </div>
    
    <div className="flex items-center">
      <button
        className="text-sm font-medium text-[#D64541] hover:text-[#A00A0A] mr-2 whitespace-nowrap disabled:opacity-50"
        onClick={() => {
          setSelectedAreas([]);
          setSelectedDesign(null);
        }}
        disabled={isApplyingDesign}
      >
        Clear All
      </button>
      <button
        onClick={() => {
          setShowDesignsPopup(false);
          setSelectedAreas([]);
          setSelectedDesign(null);
        }}
        className="p-1 rounded-full hover:bg-gray-100"
        disabled={isApplyingDesign}
      >
        <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12"></path>
        </svg>
      </button>
    </div>
  </div>
</div>

  {/* Scrollable Content Area */}
  <div className="flex-1 overflow-y-auto p-4 pb-16">
        {/* Enhanced Area Selection */}
        <div className="mb-6">
          <div className="flex justify-between items-center mb-3">
            <h4 className="font-medium text-gray-900">Select areas to apply design</h4>
            <span className="text-xs bg-gray-100 px-2 py-1 rounded-full">
              {selectedAreas.length} selected
            </span>
          </div>

          <div className="flex overflow-x-auto space-x-4 pb-2">
  {Array.from({ length: Math.ceil(selectedItem.applied_areas.length / 4) }).map((_, pageIndex) => {
    const pageAreas = selectedItem.applied_areas.slice(pageIndex * 4, pageIndex * 4 + 4);
    
    return (
      <div key={pageIndex} className="p-0.5 grid grid-cols-2 grid-rows-2 gap-5 w-[350px] shrink-0">
        {pageAreas.map((area, areaIndex) => {
          const isSelected = selectedAreas.some(a => a.area_name === area.area_name);
          const hasExistingDesign = area.selected_design;
          const existingDesign = hasExistingDesign
            ? designs.find(d => d.item_id === area.selected_design.design_id)
            : null;
          
          // Calculate the overall index of this area
          const overallIndex = pageIndex * 4 + areaIndex + 1;
          const totalAreas = selectedItem.applied_areas.length;
          
          return (
            <div
  key={area._id}
  onClick={() => handleAreaSelection(area)}
  className={`p-1.5 rounded-lg border transition-all cursor-pointer ${
    isSelected 
      ? 'border-[#D64541] bg-[#FFF5F5] shadow-md transform scale-[1.02] relative z-10' 
      : 'border-gray-200 hover:border-gray-300 hover:shadow-sm'
  }`}
>
  <div className="flex items-start">
    <div className="flex-1">
      {/* Fixed height container for area name and count */}
      <div className="flex justify-between ">
        <div className="flex-1 mr-2">
          <p className="line-clamp-2 text-sm font-medium text-gray-900">{area.area_name}</p>
        </div>
{/*         <div className="flex-shrink-0">
          <span className="text-sm text-gray-500 bg-gray-100 px-1.5 py-0.5 rounded-full whitespace-nowrap">
            {overallIndex}/{totalAreas}
          </span>
        </div> */}
      </div>
      
      {/* Design section - will now start at the same height in all cards */}
      <div className="mt-1 flex items-center gap-2">
        <div className="w-8 h-8 rounded-md overflow-hidden border flex-shrink-0 bg-gray-100">
          {hasExistingDesign && existingDesign ? (
            existingDesign.item_image ? (
              <img
                src={process.env.REACT_APP_FORE_BRICKBUCKET_IMAGES + existingDesign.item_image}
                alt={existingDesign.item_name}
                className="w-full h-full object-cover"
              />
            ) : (
              <div className="w-full h-full flex items-center justify-center text-gray-400 text-[10px]">
                No Image
              </div>
            )
          ) : (
            <div className="w-full h-full flex items-center justify-center text-red-500">
              <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
              </svg>
            </div>
          )}
        </div>
        <div className="overflow-hidden">
          <p className={`text-sm break-words line-clamp-2 ${
            hasExistingDesign && existingDesign
              ? (isSelected ? 'text-red-500' : 'text-gray-700')
              : 'text-red-500 text-xs'
          }`}>
            {hasExistingDesign && existingDesign
              ? existingDesign.item_name
              : (
                <>
                  Design<br/>not selected
                </>
              )
            }
          </p>
        </div>
      </div>
    </div>
  </div>
  </div>

          );
        })}
      </div>
    );
  })}
</div>

        </div>

        {/* Design Selection */}
        <div>
          <h4 className="font-medium text-gray-900 mb-3">Available Designs</h4>
          
          {designs.length === 0 ? (
            <div className="py-6 text-center bg-gray-50 rounded-lg">
              <p className="text-gray-500">No designs available for this tile</p>
            </div>
          ) : (
            <div className="grid grid-cols-2 gap-3">
              {designs.map((design) => (
                <div
                  key={design.item_id}
                  className={`group relative border rounded-lg overflow-hidden transition-shadow ${
                    selectedDesign?.item_id === design.item_id 
                      ? 'ring-2 ring-[#D64541]' 
                      : 'hover:shadow-md'
                  }`}
                  onClick={() => setSelectedDesign(design)}
                >
                  <div className="h-40 bg-gray-100 relative">
                    {design.item_image ? (
                      <img
                        src={process.env.REACT_APP_FORE_BRICKBUCKET_IMAGES + design.item_image}
                        alt={design.item_name}
                        className="w-full h-full object-cover"
                      />
                    ) : (
                      <div className="w-full h-full flex items-center justify-center text-gray-400">
                        No Image
                      </div>
                    )}
                    <div className="absolute top-2 right-2">
                      <div className={`w-5 h-5 rounded-full border-2 flex items-center justify-center ${
                        selectedDesign?.item_id === design.item_id 
                          ? 'bg-[#D64541] border-[#D64541]' 
                          : 'bg-white border-gray-300'
                      }`}>
                        {selectedDesign?.item_id === design.item_id && (
                          <svg className="w-3 h-3 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
                          </svg>
                        )}
                      </div>
                    </div>
                  </div>
                  
                  <div className="p-3">
                    <p className="font-medium text-xs text-gray-900">{design.item_name}</p>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>

      {/* Toast Notification */}
      {showToast && (
        <div className="mb-2 text-white fixed bottom-0 left-0 right-0 bg-green-500 border-t border-gray-200 rounded-md shadow-lg animate-fade-in-out py-4 px-4 shadow-lg z-[60]">
          <div className="flex justify-between items-center max-w-md mx-auto">
            {toastMessage}
          </div>
        </div>
      )}

      {/* Selection Summary Bar - Fixed at bottom above popup */}
      <div className="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 py-3 px-4 shadow-lg z-[55]">
  <div className="flex justify-end items-center max-w-md mx-auto">
    <div className='flex flex-row'>
      {/* Done Applying button - enabled when Apply is disabled */}
      <button 
        className={`min-w-[120px] mr-3 border px-4 py-2 rounded-md text-sm font-medium ${
          !selectedAreas.length || !selectedDesign || isApplyingDesign
            ? 'text-white bg-[#D64541]' 
            : 'bg-gray-300 text-gray-500 cursor-not-allowed border-gray-300'
        }`}
        onClick={() => {
          setShowDesignsPopup(false);
          setSelectedAreas([]);
          setSelectedDesign(null);
        }}
        disabled={selectedAreas.length > 0 && selectedDesign && !isApplyingDesign}
      >
        {selectedItem.applied_areas.some(area => area.selected_design && area.selected_design.design_id) 
          ? 'Done Applying' 
          : 'Cancel'}
      </button>
      
      {/* Apply button - disabled when conditions aren't met */}
      <button
        className={`text-sm font-medium px-4 py-2 rounded whitespace-nowrap ${
          selectedAreas.length > 0 && selectedDesign && !isApplyingDesign
            ? 'bg-[#D64541] text-white hover:bg-[#A00A0A]'
            : 'bg-gray-300 text-gray-500 cursor-not-allowed'
        } disabled:opacity-50 focus:outline-none min-w-[120px]`}
        disabled={!selectedAreas.length || !selectedDesign || isApplyingDesign}
        onClick={() => handleDesignSelect(selectedDesign)}
      >
        {isApplyingDesign ? (
          <>
            <svg className="animate-spin -ml-1 mr-2 h-4 w-4 text-white inline-block align-text-bottom" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
              <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
              <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
            </svg>
            Applying...
          </>
        ) : (
          'Apply'
        )}
      </button>
    </div>
  </div>
</div>

    </div>
  </div>
)}
{/* Tile Designs Popup ends*/}



{/* Design Popup  */}
{selectedDesignForPopup && (
  <>
    {/* Overlay */}
    <div
      className="fixed inset-0 bg-black bg-opacity-50 z-40 transition-opacity duration-300"
      onClick={() => setSelectedDesignForPopup(null)}
    ></div>
    
    {/* Popup */}
    <div className="fixed inset-x-4 top-1/2 -translate-y-1/2 bg-white rounded-xl shadow-lg z-50 max-h-[80vh] overflow-y-auto">
      {/* Header with close button */}
      <div className="flex justify-between items-center p-4 border-b border-gray-200 sticky top-0 bg-white z-10">
        <h3 className="text-lg font-semibold text-gray-800">Design Details</h3>
        <button
          onClick={() => setSelectedDesignForPopup(null)}
          className="text-gray-500 hover:text-gray-700"
        >
          <FontAwesomeIcon icon={faTimesCircle} className="w-5 h-5" />
        </button>
      </div>
      
      {/* Design image and info */}
      <div className="p-4">
        <div className="flex flex-col items-center mb-4">
          {/* Large image */}
          <div className="w-full h-48 mb-3 rounded-lg overflow-hidden border border-gray-200">
            <img
              src={process.env.REACT_APP_FORE_BRICKBUCKET_IMAGES + selectedDesignForPopup.design.design_image}
              alt={selectedDesignForPopup.design.design_name}
              className="w-full h-full object-contain"
              onError={(e) => {
                e.target.onerror = null;
                e.target.src = "https://via.placeholder.com/300?text=No+Image";
              }}
            />
          </div>
          
          {/* Design name */}
          <h4 className="text-xl font-bold text-gray-800 mb-1">
            {selectedDesignForPopup.design.design_name}
          </h4>
          
          {/* Price info if available */}
          {selectedDesignForPopup.design.design_price && (
            <p className="text-sm text-gray-600 mb-2">
              ₹{Number(selectedDesignForPopup.design.design_price).toLocaleString()}/Box
            </p>
          )}
        </div>
        
        {/* Areas where this design is applied */}
        <div className="mt-4">
          <h5 className="text-md font-semibold text-gray-700 mb-2">
            Applied in {selectedDesignForPopup.areas.length} {selectedDesignForPopup.areas.length === 1 ? 'area' : 'areas'}:
          </h5>
          
          <div className="border border-gray-200 rounded-md divide-y divide-gray-200">
            {selectedDesignForPopup.areas.map((area, index) => (
              <div key={index} className="p-3 flex justify-between items-center">
                <div>
                  <p className="text-sm font-medium text-gray-800">
                    {area.area_name || area.room_name}
                  </p>
                </div>
                <p className="text-sm font-medium">
                  {area.areaInSft || area.area} sq.ft
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
      
      {/* Footer with action button */}
      <div className="p-4 border-t border-gray-200">
        <button
          onClick={() => {
            // Close the popup
            setSelectedDesignForPopup(null);
            // You could also add navigation to a detailed design page here
          }}
          className="w-full bg-[#D64541] text-white font-medium py-2.5 px-4 rounded-md hover:bg-[#A00A0A] transition duration-200"
        >
          Close
        </button>
      </div>
    </div>
  </>
)}
{/* Design Popup ends */}


{/* Vendor Details Popup starts */}
{showVendorDetailsPopup && selectedVendorDetails && (
  <div className="fixed inset-0 bg-black/70 z-50 flex items-end sm:items-center justify-center">
    {/* Overlay with subtle fade effect */}
    <div 
      className="absolute inset-0 backdrop-blur-sm transition-opacity duration-300"
      onClick={() => setShowVendorDetailsPopup(false)}
    ></div>
    
    {/* Modern Card-style Popup */}
    <div className="relative bg-white rounded-t-2xl sm:rounded-2xl shadow-2xl w-full max-w-2xl mx-auto overflow-hidden animate-fade-in-up">
      {/* Premium Handle */}
      <div className="pt-3 flex justify-center">
        <div className="w-16 h-1.5 bg-gray-300/80 rounded-full"></div>
      </div>
      
      {/* Header with gradient */}
      <div className="relative">
        <div className="absolute inset-0 bg-gradient-to-r from-[#D64541]/10 to-[#3C5DB1]/10"></div>
        <div className="relative flex justify-between items-center p-5">
          <div>
            <h3 className="text-2xl font-bold text-gray-900">{selectedVendorDetails.name}</h3>
            <p className="text-sm text-gray-600 flex items-center">
              <FontAwesomeIcon icon={faStar} className="w-4 h-4 text-yellow-400 mr-1" />
              Premium Brand
            </p>
          </div>
          <button 
            onClick={() => setShowVendorDetailsPopup(false)}
            className="p-2 rounded-full bg-white/80 shadow-sm hover:bg-gray-100 transition-all"
          >
            <FontAwesomeIcon icon={faClose} className="w-5 h-5 text-gray-600" />
          </button>
        </div>
      </div>
      
      {/* Content with scroll-snap sections */}
      <div className="overflow-y-auto" style={{ maxHeight: '70vh' }}>
        {/* Hero Section */}
        <div className="relative h-48 bg-gradient-to-br from-gray-900 to-gray-700 flex items-center justify-center">
          <img
            src={process.env.REACT_APP_FORE_BRICKBUCKET_IMAGES + selectedVendorDetails.image}
            alt={selectedVendorDetails.name}
            className="h-32 object-contain"
          />
          <div className="absolute bottom-4 right-4 bg-[#D64541] text-white px-3 py-1 rounded-full text-xs font-bold">
            Official Partner
          </div>
        </div>
        
        {/* Tab Navigation */}
        <div className="border-b border-gray-200 sticky top-0 bg-white z-10">
          <div className="flex px-5">
            <button className="px-4 py-3 font-medium text-[#D64541] border-b-2 border-[#D64541]">
              Overview
            </button>
            <button className="px-4 py-3 font-medium text-gray-500 hover:text-gray-700">
              Products
            </button>
            <button className="px-4 py-3 font-medium text-gray-500 hover:text-gray-700">
              Specifications
            </button>
          </div>
        </div>
        
        {/* Content Sections */}
        <div className="p-5 space-y-6">
          {/* Brand Story */}
          <div className="bg-gray-50/50 p-5 rounded-xl">
            <h4 className="text-lg font-semibold mb-3 flex items-center">
              <FontAwesomeIcon icon={faBookOpen} className="w-5 h-5 text-[#3C5DB1] mr-2" />
              Brand Story
            </h4>
            <p className="text-gray-700 leading-relaxed">
              {selectedVendorDetails.description || 
                `${selectedVendorDetails.name} redefines excellence in tile manufacturing with Italian technology and sustainable practices. Each piece reflects 40+ years of craftsmanship.`}
            </p>
          </div>
          
          {/* Featured Products - Card Grid */}
          <div>
            <h4 className="text-lg font-semibold mb-3 flex items-center">
              <FontAwesomeIcon icon={faCube} className="w-5 h-5 text-[#D64541] mr-2" />
              Featured Collections
            </h4>
            <div className="grid grid-cols-2 gap-4">
              {selectedVendorDetails.product_subcategory_data?.slice(0,4).map(subcategory => (
                <div key={subcategory._id} className="group relative overflow-hidden rounded-lg border border-gray-200 hover:shadow-md transition-all">
                  <div className="aspect-square bg-gray-100 flex items-center justify-center p-4">
                  <FontAwesomeIcon icon={faCube} className="w-10 h-10 text-gray-400 group-hover:text-[#D64541] transition-colors" />
                  </div>
                  <div className="p-3">
                    <h5 className="font-medium text-gray-900 truncate">{subcategory.product_sub_category_name}</h5>
                    <div className="flex justify-between items-center mt-2">
                      <span className="text-sm font-bold text-[#D64541]">₹{subcategory.selling_price}/Box</span>
                      <button className="text-xs bg-[#D64541]/10 text-[#D64541] px-2 py-1 rounded-full hover:bg-[#D64541]/20">
                        View
                      </button>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
          
          {/* Tech Specs */}
          <div className="space-y-4">
            <h4 className="text-lg font-semibold flex items-center">
              <FontAwesomeIcon icon={faCog} className="w-5 h-5 text-gray-700 mr-2" />
              Technical Advantages
            </h4>
            <div className="grid grid-cols-2 gap-3">
              <div className="bg-white p-3 rounded-lg border border-gray-200 shadow-sm">
                <div className="flex items-center mb-2">
                  <FontAwesomeIcon icon={faShield} className="w-5 h-5 text-green-500 mr-2" />
                  <span className="font-medium">Durability</span>
                </div>
                <p className="text-xs text-gray-600">10+ year warranty against wear and tear</p>
              </div>
              <div className="bg-white p-3 rounded-lg border border-gray-200 shadow-sm">
                <div className="flex items-center mb-2">
                  <FontAwesomeIcon icon={faSwatchbook} className="w-5 h-5 text-blue-500 mr-2" />
                  <span className="font-medium">Colorfast</span>
                </div>
                <p className="text-xs text-gray-600">UV-resistant colors that won't fade</p>
              </div>
              <div className="bg-white p-3 rounded-lg border border-gray-200 shadow-sm">
                <div className="flex items-center mb-2">
                  <FontAwesomeIcon icon={faRuler} className="w-5 h-5 text-purple-500 mr-2" />
                  <span className="font-medium">Eco-Friendly</span>
                </div>
                <p className="text-xs text-gray-600">40% recycled materials used</p>
              </div>
              <div className="bg-white p-3 rounded-lg border border-gray-200 shadow-sm">
                <div className="flex items-center mb-2">
                  <FontAwesomeIcon icon={faStarHalfStroke} className="w-5 h-5 text-yellow-500 mr-2" />
                  <span className="font-medium">Finish</span>
                </div>
                <p className="text-xs text-gray-600">Nano-coating for stain resistance</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      {/* Sticky CTA */}
      <div className="sticky bottom-0 bg-white border-t border-gray-200 p-4">
        <div className="flex justify-between items-center">
          <div>
            <p className="text-xs text-gray-500">Have questions?</p>
            <p className="font-medium">Talk to our tile expert</p>
          </div>
          <button className="bg-[#D64541] text-white px-6 py-2 rounded-full font-medium hover:bg-[#A00A0A] transition-colors flex items-center">
            <FontAwesomeIcon icon={faPhone} className="w-4 h-4 mr-2" />
            Call Now
          </button>
        </div>
      </div>
    </div>
  </div>
)}
 {/* vendor details popup ends */}



 
</div>

  );
}
  

export default TilesStandardQuoteDetails;